<template>

    <Dialog
        :pt="{
            mask: { style: (data.dactive && data.dactive == true ? ' z-index: 9; ' : `z-index: ${data.index};`) }
        }"
        ref="dialogMainref"
        v-model:visible="showDialog"
        :modal="data && (data.modal === undefined || data.modal !== false) ? 'modal' : null"
        class="dynamicModal"
        :maximizable="data && data.maximize !== undefined ? data.maximize : true"
        :style="`width: ${(data && data.modal_width) || 50}vw;`"
        :fullscreen="
            data && data.fullscreen
                ? data.fullscreen
                : false
        "
        :dismissableMask="data && data.dismiss !== undefined ? data.dismiss : false"
        :closable="data && data.closable !== undefined
                ? data.closable
                : true"
        :closeOnEscape="data && data.closeOnEscape !== undefined
                ? data.closeOnEscape
                : true"
        @hide="hideDialog(data, $event)"
        @show="openDialog(data, $event)"
        @dragend="onDrag(data, $event)"
        :blockScroll="false"
        >
        <template #header>
            <div class="w-100 text-center">
                <div
                    class="fs-6 fw-bold"
                    v-html="
                        (data !== undefined && data.title !== undefined
                            ? data.title
                            : '')
                "></div>
                <div
                    class="small text-secondary"
                    v-html="
                        (data !== undefined && data.subTitle !== undefined
                            ? data.subTitle
                            : '')
                "></div>
            </div>
        </template>

        <div class="max-h-751" :class="data.dynamic_height !== undefined && data.dynamic_height == true ? 'dynamic-height' : ''">
            <component
                v-model:mainref="dialogref[data._id]"
                v-if="dynamicModal"
                :is="dynamicModal"
                :data="data"
            ></component>
        </div>

        <template #footer v-if="data && data.toolbar">
            <DAToolbar v-model:mainref="dialogref[data._id]" :data="data" />
        </template>
    </Dialog>
</template>


<script>
    import { onMounted, ref, defineAsyncComponent, computed } from "vue";

    import Dialog from "primevue/dialog";

    import DAToolbar from "@/components/toolbar/DAToolbar";
    import { G } from "@/_common";


    export default {
        name: "ModalControllerComponent",
        components:{
            Dialog,
            DAToolbar,
        },
        props: {
            data: {
                type: Object,
                default() {
                    return null;
                },
            },
        },
        setup(props) {
            const dialogref = ref({});
            const dialogMainref = ref({});

            const showDialog = ref();
            const dpage = ref(null);

            onMounted(() => {
                showDialog.value = true;
                dialogref.value = {};

                window.document.removeEventListener('keydown', dialogMainref.value.documentKeydownListener);

                dialogMainref.value.onKeyDown = async (event)=> {
                    if( event.keyCode == 27 && G.dynModal.lastDialog.closeOnEscape !== undefined && G.dynModal.lastDialog.closeOnEscape == true ){
                        if (G.dynModal.lastDialog && G.dynModal.lastDialog.onModalClose !== undefined){
                            await G.dynModal.lastDialog.onModalClose(G.dynModal.lastDialog, event);
                        }
                        G.closeModal(G.dynModal.lastDialog);
                        return false;
                    }
                    return false;
                };
            });

            const hideDialog = (dlg, event) => {
                // if onModalClose function is present
                if (dlg && dlg.onModalClose !== undefined){
                    dlg.onModalClose(dlg, event);
                    return false;
                }
                G.closeModal(dlg, event);
                showDialog.value = false;
                delete dialogref.value[dlg._id];
            };

            const openDialog = (dlg, event) => {
                dpage.value = dlg.page;
                dialogref.value[dlg._id] = dlg;
                if (dlg && dlg.onModalOpen !== undefined){
                    dlg.onModalOpen(dlg, event);
                }
            };

            const onDrag = (dlg, event) => {
                G.activateModal(dlg, event);
            };

            const dynamicModal = computed(() => {
                if (dpage.value) {
                    return defineAsyncComponent({
                        loader: () => import(`@/${dpage.value}`).then(
                            (mod) => {
                                return mod;
                            },
                            () => {
                                return import('@/system_modules/NotFound');
                            }
                        ),
                        loadingComponent:
                            '<center><i class="fa fa-sync fa-spin"></i></center>',
                        // errorComponent: import("@/system_modules/NotFound")
                        errorComponent:
                            defineAsyncComponent(() =>
                                import('@/system_modules/NotFound')
                            ),
                        // timeout: 3000,
                        // suspensible: false,
                    });
                } else {
                    return defineAsyncComponent({
                        loader: () => import(`@/system_modules/NotFound`)
                    });
                }
            });

            return {
                dialogref,
                dialogMainref,
                showDialog,
                hideDialog,
                openDialog,
                onDrag,
                dynamicModal,
            };
        },
    };
</script>


<style lang="scss">
    .p-dialog {
        // max-height: 90vh;
        -webkit-transform: unset;
        transform: unset;
    }
    // .p-overflow-hidden {
    //     overflow: unset;
    // }

    .p-component-overlay-enter {
        // -webkit-animation: p-component-overlay-enter-animation 150ms forwards;
        // animation: p-component-overlay-enter-animation 150ms forwards;
        -webkit-animation: unset;
        animation: unset;
        transform: unset;
    }
    .p-component-overlay {
        background-color: rgba(0, 0, 0, 0.4);
        transition-duration: unset;
        transform: unset;
    }

    .p-dialog .p-dialog-content {
        // padding: 0.2rem;
        padding: 0rem;
        height: calc(100vh - 300px);
        max-height: calc(100vh - 300px);
    }
    .p-dialog.p-dialog-maximized .p-dialog-content {
        padding: 0.2rem;
        height: calc(100vh - 100px);
        max-height: calc(100vh - 100px);
    }
    .p-dialog .p-dialog-content:has(.dynamic-height) {
        min-height: auto !important;
        height: 100%;
    }
    .p-dialog .p-dialog-header {
        border-bottom: 1px solid #c4bdbd;
        padding: 0.5rem 0.9rem;
    }
    .p-dialog .p-dialog-footer {
        border-top: 1px solid #c4bdbd;
        // padding: 1rem;
        padding: 0.6rem 0.9rem;
    }

    // .p-datepicker {
    //     width: 350px !important;
    // }
    .p-datepicker table td > span {
        width: 2rem !important;
        height: 2rem !important;
    }

    .p-dialog-enter-active {
        transition: unset;
    }
    .p-dialog-leave-active {
        transition: unset;
    }

    @media (max-width: 576px) {
        .dynamicModal {
            width: 100vw !important;
        }
        .p-dialog .p-dialog-content {
            height: calc(100vh - 100px);
            max-height: calc(100vh - 100px);
        }
    }
</style>
